module.exports = __webpack_public_path__ + "img/2.0bfd306a.png";